import {
	Button,
	designTokens,
	Flex,
	FormControl,
	FormGroup,
	InputRadio,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Modalv2
} from "@itandi/itandi-bb-ui";
import type { ChangeEvent } from "react";
import { useState } from "react";

type Props = {
	onClose: () => void;
	onDownload: (imagesPerPage: number) => void;
};

export function ReportPdfDownloadModal({ onClose, onDownload }: Props) {
	const [imagesPerPage, setImagesPerPage] = useState(2);

	const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
		setImagesPerPage(Number(e.target.value));
	};

	return (
		<Modalv2 isOpen onClose={onClose} size="s">
			<ModalHeader title="報告書ダウンロード" />
			<ModalBody>
				<FormGroup variant="vertical">
					<FormControl label="1ページあたりの画像の出力枚数">
						<Flex gap={designTokens["spacing/xs"]}>
							<InputRadio
								checked={imagesPerPage === 2}
								label="2枚"
								name="imagesPerPage"
								onChange={handleChange}
								value="2"
							/>
							<InputRadio
								checked={imagesPerPage === 3}
								label="3枚"
								name="imagesPerPage"
								onChange={handleChange}
								value="3"
							/>
							<InputRadio
								checked={imagesPerPage === 4}
								label="4枚"
								name="imagesPerPage"
								onChange={handleChange}
								value="4"
							/>
						</Flex>
					</FormControl>
				</FormGroup>
			</ModalBody>
			<ModalFooter
				leftArea={
					<Button onClick={onClose} variant="secondary">
						キャンセル
					</Button>
				}
				rightArea={
					<Button
						onClick={() => {
							onDownload(imagesPerPage);
							onClose();
						}}
						variant="primary"
					>
						ダウンロード
					</Button>
				}
			/>
		</Modalv2>
	);
}
